import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-12 px-4 text-center" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <h3 className="text-2xl font-black text-white mb-4" data-id="element-109">
          ❄️ PACK COMPLETO DE REFRIGERACIÓN
        </h3>
        <p className="mb-8 italic text-lg" data-id="element-110">
          El oficio que aprendés hoy es la libertad que tenés mañana.
        </p>

        <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-111">
          <p className="mb-4 font-medium" data-id="element-112">
            © 2025 GUÍA DIGITAL 360 — Todos los derechos reservados. 🇦🇷
          </p>
          <div className="flex justify-center gap-4" data-id="element-113">
            <a href="#" className="hover:text-white transition-colors" data-id="element-114">
              Privacidad
            </a>
            <span data-id="element-115">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-116">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}